export const msalConfig = {
  auth: {
    clientId: '',
    authority: '',
    redirectUri: '',
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: [] as string[],
}

export const userInfo = {
  userName: '',
  userMailId: '',
  signalRConnectionId: '',
}

export const imageBrowser = {
  url: '',
}

export const oneArticleModal = {
  url: '',
}

export const articlePurposeUrl = {
  url: '',
}

export const matchingArticleUrl = {
  url: '',
}

export const colorwayUrl = {
  url: '',
}

export const msalService = {
  account: null,
  instance: null,
}

export const carryOverFlag = {
  flag: '',
}
